export const throwErrorForDev = message => {
    if (process.env.NODE_ENV?.trim() !== 'production') {
        throw new Error(`DEVELOPMENT ERROR: ${message}`);
    }
};

export const outputDeprecationWarning = message => {
    if (process.env.NODE_ENV?.trim() !== 'production') {
        console.warn(`DEPRECATION ALERT: ${message}`);
    }
};
